/*
* Uses the browser provided latitude and longitude to lookup the associated zipcode via Google's Geocoder API
* returns zip code as a String, e.g. "90210"
*/
// function getZipCode() {
//     navigator.geolocation.getCurrentPosition((position) => {
//         let lat = position.coords.latitude;
//         let long = position.coords.longitude;
//         let latlng = {
//             lat: parseFloat(lat),
//             lng: parseFloat(long),
//         };

//         const geocoder = new google.maps.Geocoder();
//         geocoder
//         .geocode({ location: latlng })
//             .then((response) => {
//                 if (response.results[0]) {
//                     let zipInfo = response.results[0].address_components.find(function (component) {
//                         return component.types[0] == "postal_code";
//                     });
//                     let zipCode = zipInfo.long_name;
//                     const event = new CustomEvent("customer:zip_identified", { detail: zipCode });
//                     document.dispatchEvent(event);
//                 }
//             })
//         .catch((e) => window.alert("Geocoder failed due to: " + e));
//     },
//     (error) => {
//         if (error.code == error.PERMISSION_DENIED) {
//             const event = new CustomEvent("customer:location_permission_denied");
//             document.dispatchEvent(event);
//         }
//     });
// }
/*
* Checks to see if zip code entered is in the 12 state footprint
* 5xxxx covers 6 States: MT, ND, SD, MN, IA, WI
* 6xxxx covers 4 States: NE, KS, MO, IL
* 48xxx and 49xxx covers MI
* 82xxx and 831xx covers WY
*/
function checkExtendedCoverage(evaluateZip, address) {
    if (evaluateZip.length == 0 || address.country != "US") {
        console.log("Invalid Zip: " + address.city + " " + address.region + " " + address.country)
    } else {
        console.log(address.city + " " + address.region + " " + address.country)
        return (evaluateZip.startsWith("5") || evaluateZip.startsWith("6") || evaluateZip.startsWith("48") || evaluateZip.startsWith("49") || evaluateZip.startsWith("82") || evaluateZip.startsWith("831"))
    }
}

function getCurrentPosition() {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
    });
}

function getZipCode() {
    getCurrentPosition()
        .then((position) => {
            let lat = position.coords.latitude;
            let long = position.coords.longitude;
            let latlng = {
                lat: parseFloat(lat),
                lng: parseFloat(long),
            };

            const geocoder = new google.maps.Geocoder();
            return geocoder.geocode({ location: latlng }); // Return the promise
        })
        .then((response) => {
            if (response.results[0]) {
                let zipInfo = response.results[0].address_components.find((component) => {
                    return component.types.includes("postal_code");
                });

                if (zipInfo && zipInfo.long_name) {
                    let zipCode = zipInfo.long_name;
                    const event = new CustomEvent("customer:zip_identified", { detail: zipCode });
                    document.dispatchEvent(event);
                } else {
                    console.error("Postal code not found in address components.");
                }
            } else {
                console.error("No results found from geocoding.");
            }
        })
        .catch((error) => {
            // Handle errors from either geolocation or geocoding
            if (error.code === error.PERMISSION_DENIED) {
                const event = new CustomEvent("customer:location_permission_denied");
                document.dispatchEvent(event);
            } else {
                console.error("Error:", error);
            }
        });
}

/*
* Saves zip code and store information in a cookie
*/
function saveLocation(slumberlandData) {
    const cookieName = "slumberland-geo";

    try {
        const json = JSON.stringify(slumberlandData);

        // Save current customer info separately
        localStorage.setItem('SlumberlandCustomer', json);


        // Save to cookie (fallback)
        const d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000)); // 1 day expiry
        const expires = "expires=" + d.toUTCString();
        document.cookie = `${cookieName}=${json};${expires};path=/`;

        // Update global object
        window.slumberland.customer = Object.assign({}, window.slumberland.customer || {}, slumberlandData);

    } catch (e) {
        console.error('[Geo] Failed to save location:', e);
    }
}



/*
* Gets the contents of the slumberland-geo cookie
*/
function getCookieData(cookieName) {
    let name = cookieName + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) == 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }
    return null;
}

/*
* Helper function to dispatch zip data
*/
function dispatchYextEvent(apiResponse) {
    const event = new CustomEvent("yext:nearby_stores_available_geo", {
        detail: apiResponse
    });
    document.dispatchEvent(event);
}

/*
* Cleans up old cahced zips
*/
function cleanUpZipCacheIfNeeded() {
    const now = Date.now();
    const lastClean = parseInt(localStorage.getItem('zipCacheLastClean') || '0', 10);
    const cleanThreshold = 1000 * 60 * 60 * 24 * 7; // 7 days
    const freshnessThreshold = 1000 * 60 * 60 * 24; // 24 hours
  
    if (now - lastClean < cleanThreshold) return;
  
    const zipCache = JSON.parse(localStorage.getItem('zipCache') || '{}');
    let updated = false;
  
    for (const zip in zipCache) {
      const entry = zipCache[zip];
      if (!entry.timestamp || now - entry.timestamp > freshnessThreshold) {
        delete zipCache[zip];
        updated = true;
      }
    }
  
    if (updated) {
      localStorage.setItem('zipCache', JSON.stringify(zipCache));
    }
  
    localStorage.setItem('zipCacheLastClean', now.toString());
  
    // Also remove lastGeoZip if it no longer exists
    const lastZip = localStorage.getItem('lastGeoZip');
    if (lastZip && !zipCache[lastZip]) {
      localStorage.removeItem('lastGeoZip');
    }
}  

/*
* Gets the customer's nearby stores from yext
* Documentation: https://hitchhikers.yext.com/docs/contentdeliveryapis/legacy/entities
* Example request URL: https://cdn.yextapis.com/v2/accounts/me/entities/geosearch?api_key=d19a7bf02d89e1718835a43d3cea0c77&v=20240402&location="50047"&radius=30&limit=5
*/
function getNearbyStoresGEO(postal_code) {
    const freshnessThreshold = 1000 * 60 * 60 * 24; // 24 hours
    const now = Date.now();
  
    // Clean up once a week
    cleanUpZipCacheIfNeeded();
  
    const cachedData = ZipCache.get(postal_code);
  
    if (cachedData) {
      localStorage.setItem('lastGeoZip', postal_code);
      dispatchYextEvent(cachedData);
      return;
    }
  
    const yextEndpoint = "https://cdn.yextapis.com/v2/accounts/me/entities/geosearch";
    const yextApiKey = "d19a7bf02d89e1718835a43d3cea0c77";
    const version = "20240402";
    const url = `${yextEndpoint}?api_key=${yextApiKey}&v=${version}&location=${postal_code}&radius=2000&limit=5`;
  
    fetch(url)
      .then(response => response.json())
      .then(data => {
        const storeData = data.response;
        ZipCache.set(postal_code, storeData);
        localStorage.setItem('lastGeoZip', postal_code);
        dispatchYextEvent(storeData);
      })
      .catch(error => {
        console.error('Error fetching nearbyStores:', error);
    });
}
  

/*
* Takes in a stores military hours (15) and returns a standard time string (3PM)
*/
function convertToStandardTime(militaryTime) {
    const hour = Number(militaryTime); // Ensure it's a number
    const meridian = hour >= 12 ? 'PM' : 'AM';
    let standardTime = hour % 12;
    standardTime = standardTime === 0 ? 12 : standardTime; // Convert 0 to 12
    return standardTime + meridian;
}

/*
* Takes in a stores hours and returns a date message
*/
function getDateMessage(store) {
    const storeHours = store.hours;
    const holiday = store.hours.holidayHours ?? [];
    const reopenDate = store.hours?.reopenDate;
    const dayMap = {
        '0': 'Sunday',
        '1': 'Monday',
        '2': 'Tuesday',
        '3': 'Wednesday',
        '4': 'Thursday',
        '5': 'Friday',
        '6': 'Saturday',
    }
    const date = new Date();
    const formattedDate = date.toISOString().split('T')[0]; // get formatted date to match to holiday date closed
    const currentDayNumber = date.getDay(); // returns the day as an integer
    const currentDayName = dayMap[currentDayNumber]; // returns the day name (currentDayNumber 0 returns 'sunday')
    const currentHour = date.getHours(); // returns the current hour (4:00am returns 4, 3:00pm returns 15)
    const maxLookaheadDays = 14; // check 2 weeks into the future
    const todayHoliday = holiday.find(h => h.date === formattedDate);
    let closed = false;
    let nextDayOpenName;
    let nextDayOpenTime;
    let nextDayCloseTime;
    let storeOpenToday;
    let storeCloseToday;
    let dateMessage;

    function getDayName(date) {
        return dayMap[date.getDay()];
    }

    function formatDate(dateStr) {
        if (!dateStr) return "";

        const date = new Date(dateStr);
        return new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            timeZone: 'UTC'
        }).format(date);
    }

    if (reopenDate) {
        return dateMessage = `${window.slumberland.messages.store_temp_closed} ${formatDate(reopenDate)}`;
    }

    for (let i = 1; i < maxLookaheadDays; i++) {
        const checkDate = new Date();
        checkDate.setDate(date.getDate() + i);
        const checkDayName = getDayName(checkDate).toLowerCase();
        const checkFormatted = checkDate.toISOString().split('T')[0];

        const holidayMatch = holiday.find(h => h.date === checkFormatted);
        if (holidayMatch) {
            if (holidayMatch?.isClosed) continue;
            if (holidayMatch?.openIntervals && holidayMatch?.openIntervals.length > 0) {
                nextDayOpenName = getDayName(checkDate);
                nextDayOpenTime = holidayMatch?.openIntervals[0].start.split(':')[0];
                nextDayCloseTime = holidayMatch?.openIntervals[0].end.split(':')[0];
                break;
            }
        }

        const regularHours = store.hours[checkDayName];
        if (regularHours && regularHours.openIntervals && regularHours.openIntervals.length > 0) {
            nextDayOpenName = getDayName(checkDate);
            nextDayOpenTime = regularHours.openIntervals[0].start.split(':')[0];
            nextDayCloseTime = regularHours.openIntervals[0].end.split(':')[0];
            break;
        }
    }

    if (todayHoliday) {
        closed = false; // if there is a holiday, use holiday messaging
    } else if (storeHours[currentDayName.toLowerCase()]?.isClosed) {
        closed = true; // if no holiday && closed, use closed messaging
    } else if (storeHours[currentDayName.toLowerCase()]?.openIntervals) {
        // set standard open messaging
        storeOpenToday = Number(storeHours[currentDayName.toLowerCase()].openIntervals[0].start.split(':')[0]);
        storeCloseToday = Number(storeHours[currentDayName.toLowerCase()].openIntervals[0].end.split(':')[0]);
    }

    // Handle closed, holiday closed, holiday hours, standard hours, catch all for next open date/time
    if (closed) {
        dateMessage = `${window.slumberland.messages.closed} ${convertToStandardTime(nextDayOpenTime)} ${nextDayOpenName}`;
    } else if (todayHoliday) {
        if (todayHoliday?.isClosed) {
            dateMessage = `${window.slumberland.messages.holiday_closed} ${convertToStandardTime(nextDayOpenTime)} ${nextDayOpenName}`;
        } else if (todayHoliday && todayHoliday?.openIntervals && todayHoliday?.openIntervals.length > 0) {
            const open = Number(todayHoliday?.openIntervals[0].start.split(':')[0]);
            const close = Number(todayHoliday?.openIntervals[0].end.split(':')[0]);

            if (currentHour < open) {
                dateMessage = `${window.slumberland.messages.holiday_opens_at} ${convertToStandardTime(open)}`;
            } else if (currentHour >= open && currentHour <= close) {
                dateMessage = `${window.slumberland.messages.holiday_open_until} ${convertToStandardTime(close)}`;
            } else {
                dateMessage = `${window.slumberland.messages.opens_at} ${convertToStandardTime(nextDayOpenTime)} ${nextDayOpenName}`;
            }
        }
    } else if (currentHour < storeOpenToday) {
        dateMessage = `${window.slumberland.messages.opens_at} ${convertToStandardTime(storeOpenToday)}`;
    } else if (currentHour >= storeOpenToday && currentHour <= storeCloseToday) {
        dateMessage = `${window.slumberland.messages.open_until} ${convertToStandardTime(storeCloseToday)}`;
    } else {
        dateMessage = `${window.slumberland.messages.opens_at} ${convertToStandardTime(nextDayOpenTime)} ${nextDayOpenName}`;
    }

    if (!dateMessage || dateMessage.includes('undefined')) {
        dateMessage = window.slumberland.messages.store_hour_error;
    }
    return dateMessage;
}

// helper function to get current customer zip data for updateDOM function
function getZipData() {
    try {
        const cached = localStorage.getItem('zipCache');
        if (!cached) return null;

        const parsed = JSON.parse(cached);
        if (parsed.zipCode && parsed.storeId) {
            return parsed;
        }
        return null;
    } catch (e) {
        console.error('Error reading SlumberlandCustomer:', e);
        return null;
    }
}

function hydrateCustomerFromStorage() {
    window.slumberland = window.slumberland || {};
    window.slumberland.customer = window.slumberland.customer || {};
    window.slumberland.nearbyStores = [];
  
    const zipCache = JSON.parse(localStorage.getItem('zipCache') || '{}');
    const lastZip = localStorage.getItem('lastGeoZip');
    const freshnessThreshold = 1000 * 60 * 60 * 24; // 24 hours
    const now = Date.now();
  
    if (lastZip && zipCache[lastZip]) {
      const cachedEntry = zipCache[lastZip];
  
      if (now - cachedEntry.timestamp < freshnessThreshold) {  
        window.slumberland.customer.zipCode = lastZip;
        window.slumberland.customer.storeId = cachedEntry.data?.entities?.[0]?.meta?.id || null;
        window.slumberland.nearbyStores = cachedEntry.data?.entities || [];
  
        return true;
      } else {
        // Stale — remove from cache
        delete zipCache[lastZip];
        localStorage.setItem('zipCache', JSON.stringify(zipCache));
        localStorage.removeItem('lastGeoZip');
      }
    }
  
    // Optionally fallback to SlumberlandCustomer object if it exists
    const json = localStorage.getItem('SlumberlandCustomer');
    if (json) {
      try {
        const parsed = JSON.parse(json);
        window.slumberland.customer = Object.assign({}, window.slumberland.customer, parsed);
        return true;
      } catch (e) {
        console.warn('[Geo] Failed to parse SlumberlandCustomer:', e);
      }
    }
  
    const cookieData = getCookieData("slumberland-geo");
    if (cookieData) {
      try {
        const parsed = JSON.parse(cookieData);
        window.slumberland.customer = Object.assign({}, window.slumberland.customer, parsed);
        return true;
      } catch (e) {
        console.warn('[Geo] Invalid cookie format');
      }
    }
  
    return false;
  }
  


/*
* Updates the UI with customer geolocation and assigned store data
*/
function updateDOM() {
    let storeObj = window.allStoreLocations;
    // Display Zip Code //
    let elGeoZips = document.getElementsByClassName("geo-zip-code");
    const zipCode = window.slumberland.customer.zipCode;
    const nearbyStores = window.slumberland.nearbyStores;
    const deliveryZipSet = window.slumberland.deliveryZipSet;

    if (zipCode && nearbyStores && nearbyStores.length > 0) {
        for (let elZip of elGeoZips) {
            elZip.innerHTML = zipCode;
            elZip.classList.remove('hide');
        }
        if (nearbyStores && nearbyStores.length > 0) {
            // hide the store unavailable messaging
            //let elNoStores = document.getElementsByClassName("js-geo-store-unavailable, js-geocode-extended-shipping");
            let elNoStores = document.querySelectorAll('.js-geo-store-unavailable, .js-geocode-extended-shipping');
            let elStoreLocatorIcon = document.getElementsByClassName("store-locator");
            let elPickupIcon = document.getElementsByClassName("store-pickup");
            for (let elNoStore of elNoStores) {
                elNoStore.classList.add('hide');
            }
            let matchedElements = document.querySelectorAll('.js-geocode-store,.js-geocode-delivery,.js-geocode-divider');
            for (let element of matchedElements) {
                element.classList.remove('hide');
            }
            for (let icon of elStoreLocatorIcon) {
                icon.classList.add('hide');
            }
            for (let icon of elPickupIcon) {
                icon.classList.remove('hide');
            }
        }
    } else if (zipCode) {
        for (let elZip of elGeoZips) {
            elZip.innerHTML = zipCode;
            elZip.classList.remove('hide');
        }
    }

    // Display Store Name //
    let customerStoreId = window.slumberland.customer.storeId;
    if (customerStoreId && 'nearbyStores' in window.slumberland) {
        let elGeoStores = document.getElementsByClassName("geo-store");
        let current_store;
        for (let _nearbyStore of window.slumberland.nearbyStores) {
            if (_nearbyStore.meta.id == customerStoreId) {
                current_store = _nearbyStore;
                break;
            }
        }

        if (current_store) {
            for (let elStore of elGeoStores) {
                elStore.innerHTML = current_store.geomodifier;
                if (elStore.id == "header-geo-store") {
                    elStore.innerHTML = `<a href="${current_store.websiteUrl?.url}" target="_blank" onclick="dataLayer.push({
                        event: 'Store Page Click',
                        category: 'engagement',
                        action: 'link_click',
                        label: '${current_store.geomodifier}',
                        value: 1
                      });">${current_store.geomodifier}<a/>`;
                }
                else {
                    elStore.innerHTML = `<modal-opener class="no-js-hidden" data-modal="modal-see-in-store"><button style="text-decoration:underline; font-weight: 700;">See in Store?</button></modal-opener>`;
                }
                elStore.dataset.url = current_store.websiteUrl?.url;
                elStore.classList.remove('hide');
            }
            // hide the store unavailable messaging
            let elNoStores = document.querySelectorAll('.js-geo-store-unavailable, .js-geocode-extended-shipping');
            for (let elNoStore of elNoStores) {
                elNoStore.classList.add('hide');
            }
            // display store hours
            let dateMessage = getDateMessage(current_store);
            document.getElementById('open-message').innerHTML = dateMessage;
        }
    }
    // Display Zip Code Unavailable Messaging //
    let elDeliveryUnavailability = document.getElementsByClassName("delivery-unavailability");
    let elStoreLocatorIcon = document.getElementsByClassName("store-locator");
    let elPickupIcon = document.getElementsByClassName("store-pickup");

    if (!zipCode) {
        for (let element of elDeliveryUnavailability) {
            element.innerHTML = element.dataset.noZip;
        }
        for (let icon of elStoreLocatorIcon) {
            icon.classList.remove('hide');
        }
        for (let icon of elPickupIcon) {
            icon.classList.add('hide');
        }
    } else if (!deliveryZipSet?.has(zipCode)) {
        for (let element of elDeliveryUnavailability) {
            element.innerHTML = element.dataset.noDelivery;
        }
    }


    // Display Unavailable Data Messaging //
    if (!zipCode || !deliveryZipSet?.has(zipCode)) {
        let elNoStores = document.getElementsByClassName("js-geo-store-unavailable");
        for (let elNoStore of elNoStores) {
            // potentially add js here to update icon to svg? Can I reference a file there? 
            // OR add block in availability.liquid file to create line to hide/show depending on zip known or not
            elNoStore.classList.remove('hide');
        }
    
        let matchedElements = document.querySelectorAll(
            '.js-geocode-delivery,.js-geocode-extended-shipping'
        );
        for (let element of matchedElements) {
            element.classList.add('hide');
        }
    }

    // Hide store/delivery elements ONLY when no store ID
    if (!customerStoreId) {
        let matchedElements = document.querySelectorAll(
            '.js-geocode-store,.js-geocode-delivery,.js-geocode-divider,.js-geocode-extended-shipping'
        );
        for (let element of matchedElements) {
            element.classList.add('hide');
        }
    
        let elNoStores = document.getElementsByClassName("js-geo-store-unavailable");
        for (let elNoStore of elNoStores) {
            elNoStore.classList.remove('hide');
        }
    }

    // Display Extended Available Data Messaging //
    if (customerStoreId == 'Z1') {
        let elNoStores = document.getElementsByClassName("js-geocode-extended-shipping");
        for (let elNoStore of elNoStores) {
            elNoStore.classList.remove('hide');
        }
        let matchedElements = document.querySelectorAll('.js-geocode-store,.js-geocode-delivery,.js-geocode-divider,.js-geo-store-unavailable');
        for (let element of matchedElements) {
            element.classList.add('hide');
        }
    }

    // Display Cart Messaging //
    let elCartMessage = document.getElementById('cart-geolocation-message');
    if (elCartMessage) {
        let message = '';
        if (slumberland.customer.storeId) {
            message = elCartMessage.dataset.available + ' ' + slumberland.customer.zipCode;
            elCartMessage.innerHTML = message;
        } else {
            message = `<div>${elCartMessage.dataset.unavailable} ${slumberland.customer.zipCode}, </div><div>${elCartMessage.dataset.storepickup}</div>`;
            elCartMessage.innerHTML = message;
        }
    }
}

/*
* Handles click events on geolocation elements
*/
function handleClickEvents() {
    let elHeaderGeoZipCodeForm = document.getElementById('header-geo-zip-form');
    let elPdpGeoZipCodeForm = document.getElementById('pdp-geo-zip-form');

    let elGeoZipCodes = document.getElementsByClassName('geo-zip-code');
    let elGeoZipCodesEdit = document.getElementsByClassName('geo-zip-edit');
    let elGeoElements = Array.from(elGeoZipCodes).concat(Array.from(elGeoZipCodesEdit));

    for (let elGeoZipCode of elGeoElements) {
        elGeoZipCode.addEventListener('click', function (e) {
            if (this.dataset.location == "header") {
                modifySiblings(elHeaderGeoZipCodeForm, 'add', 'js-zip-form-active');

                elHeaderGeoZipCodeForm.classList.remove('hide');
                let zipInput = elHeaderGeoZipCodeForm.getElementsByClassName('geo-zip-input')[0];
                zipInput.focus();
                zipInput.value = '';
            } else {
                modifySiblings(elPdpGeoZipCodeForm, 'add', 'js-zip-form-active');

                elPdpGeoZipCodeForm.classList.remove('hide');
                let zipInput = elPdpGeoZipCodeForm.getElementsByClassName('geo-zip-input')[0];
                zipInput.value = '';
                zipInput.focus();
            }
        });
    }

    elHeaderGeoZipCodeForm.addEventListener('submit', handleZipSubmit);
    if (elPdpGeoZipCodeForm)
        elPdpGeoZipCodeForm.addEventListener('submit', handleZipSubmit);

    function handleZipSubmit(e) {
        e.preventDefault(); //prevent the form from submitting so that we can override the default behavior
        this.classList.add('hide');
        modifySiblings(this, 'remove', 'js-zip-form-active');

        let zipInput = this.getElementsByClassName('geo-zip-input')[0];
        if (isValidUSZipCode(zipInput.value)) {
            const event = new CustomEvent("customer:zip_identified", { detail: zipInput.value });
            document.dispatchEvent(event);
        }
    }

    if (elHeaderGeoZipCodeForm) {
        elHeaderGeoZipCodeForm.addEventListener('focusout', function (event) {
            if (!elHeaderGeoZipCodeForm.contains(event.relatedTarget)) {
                // Handle the form losing focus
                elHeaderGeoZipCodeForm.classList.add('hide');
                modifySiblings(elHeaderGeoZipCodeForm, 'remove', 'js-zip-form-active');
            }
        });
    }
    if (elPdpGeoZipCodeForm) {
        elPdpGeoZipCodeForm.addEventListener('focusout', function (event) {
            if (!elPdpGeoZipCodeForm.contains(event.relatedTarget)) {
                // Handle the form losing focus
                elPdpGeoZipCodeForm.classList.add('hide');
                modifySiblings(elPdpGeoZipCodeForm, 'remove', 'js-zip-form-active');
            }
        });
    }
}

function isValidUSZipCode(zip) {
    const zipCodePattern = /^\d{5}(-\d{4})?$/;
    return zipCodePattern.test(zip);
}

/*
* Utility function for getting child elements with the ability to skip an element
*/
function modifyChildren(n, skipMe, modification, className) {
    for (; n; n = n.nextSibling)
        if (n.nodeType != null && n.nodeType == 1 && n != skipMe)
            if (modification == 'add')
                n.classList.add(className)
            else
                n.classList.remove(className)
};

/*
* Utility function for getting sibling elements
*/
function modifySiblings(n, modification, className) {
    return modifyChildren(n.parentNode.firstChild, n, modification, className);
}

/*
* Utility function for adding class to elements
*/
function addClassToElements(elementList, className) {
    for (element of elementList) {
        element.classList.add(className);
    }
}

/*
* Utility function for removing class to elements
*/
function removeClassFromElements(elementList, className) {
    for (element of elementList) {
        element.classList.remove(className);
    }
}

function getSessionIP() {
    fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
            window.slumberland.customer.ip = data.ip;
        })
        .catch(error => {
            console.error('Error fetching IP address:', error);
        });
}

/*
* Initializes localStorage caching
*/
const ZIP_CACHE_KEY = 'zipCache';
const TTL = 24 * 60 * 60 * 1000; // 24 hours

const ZipCache = {
  getCache() {
    try {
        return JSON.parse(localStorage.getItem(ZIP_CACHE_KEY) || '{}');
      } catch (e) {
        console.warn('[ZipCache] Corrupt localStorage. Resetting.');
        localStorage.removeItem(ZIP_CACHE_KEY);
        return {};
      }
  },
  saveCache(cache) {
    localStorage.setItem(ZIP_CACHE_KEY, JSON.stringify(cache));
  },
  isFresh(timestamp, ttl = TTL) {
    return Date.now() - timestamp < ttl;
  },
  get(zip) {
    const cache = this.getCache();
    const entry = cache[zip];
    return entry && this.isFresh(entry.timestamp) ? entry.data : null;
  },
  set(zip, data) {
    const cache = this.getCache();

    const entities = data?.entities;
    const distances = data?.distances;
    const geo = data?.geo;

    if (!Array.isArray(entities) || !Array.isArray(distances)) {
        console.warn(`[ZipCache] Missing or malformed response for zip: ${zip}`);
        return;
    }

    const trimmedEntities = entities.map(entity => ({
        geomodifier: entity.geomodifier,
        pickupAndDeliveryServices: entity.pickupAndDeliveryServices,
        address: entity.address,
        hours: entity.hours,
        websiteUrl: entity.websiteUrl,
        localPhone: entity.localPhone,
        mainPhone: entity.mainPhone,
        meta: entity.meta
    }));
    
    const trimmedDistances = distances.map(distance => ({
        id: distance.id,
        distanceMiles: distance.distanceMiles,
        distanceKilometers: distance.distanceKilometers
    }));

    const normalized = {
        entities: trimmedEntities,
        distances: trimmedDistances,
        geo: geo
    };

    cache[zip] = {
        data: normalized,
        timestamp: Date.now()
    };

    this.saveCache(cache);
  }
};

/*
* Initializes geolocation feature
*/
function init() {
    // 1. Ensure slumberland globals
    window.slumberland = window.slumberland || {};
    window.slumberland.customer = window.slumberland.customer || {};
    window.slumberland.nearbyStores = [];
  
    // 2. Attach ALL listeners first (before hydrate, before dispatch)
    document.addEventListener("yext:nearby_stores_available_geo", (e) => {
      const nearbyStores = e.detail.entities;
      const zipCode = e.detail.geo?.address?.postalCode;
  
      let storeId = '';
      let storeList = [];
      if (nearbyStores?.length > 0) {
        storeList = nearbyStores.map(s => s.meta.id);
        storeId = storeList[0];
      } else if (checkExtendedCoverage(zipCode, e.detail.geo.address)) {
        storeId = 'Z1';
      }
  
      window.slumberland.customer = {
        zipCode,
        storeId,
        nearbyStores: storeList
      };
  
      window.slumberland.nearbyStores = nearbyStores || [];
      window.slumberland.geo_changed = 1;
  
      saveLocation(window.slumberland.customer);
      updateDOM();
    });
  
    document.addEventListener("customer:zip_identified", (e) => {
      const zipCode = e.detail;
      if (!zipCode) return;
      window.slumberland.customer = {
        ...window.slumberland.customer,
        zipCode: null // Force refresh
      };
      getNearbyStoresGEO(zipCode);
    });
  
    document.addEventListener("customer:location_permission_denied", () => {
      updateDOM();
    });
  
    // 3. Hydrate from storage
    const hydrated = hydrateCustomerFromStorage();
  
    // 4. Lookup if needed
    if (hydrated && window.slumberland.customer?.zipCode) {
      getNearbyStoresGEO(window.slumberland.customer.zipCode);
    }
  
    // 5. Fallback to browser geolocation if ZIP missing
    if (!window.slumberland.customer?.zipCode) {
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDqKlDSGbjdlLGOwPK9h2AaSD2r-9yFuFs&callback=getZipCode&v=weekly';
      document.head.appendChild(script);
    }
  
    // 6. IP fetch
    if (!window.slumberland.customer?.ip) {
      getSessionIP();
    }
  
    // 7. Final setup
    handleClickEvents();
  }
  

init();